export default () => window.location.hostname;
